import React, { useEffect, useState } from 'react';
import Footer from './footer.js';
const SERVICES_API = 'https://renderplayz.com/api/services_api.json';

const Services = () => {
    const [services, setServices] = useState(null);

    useEffect(() => {
        let active = true;

        fetch(SERVICES_API)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`No se pudo cargar ${SERVICES_API}`);
                }
                return response.json();
            })
            .then(data => {
                if (active) {
                    setServices(data);
                }
            })
            .catch(error => {
                console.log(error);
                if (active) {
                    setServices([]);
                }
            });

        return () => {
            active = false;
        };
    }, []);

    return (
        <div className="services_page">

            <div className="services_header">
                <h1 className="section_titles">Servicios Render Playz</h1>
            </div>

            {
                services === null
                ?
                <div className="load_screen2">CARGANDO...</div>
                :
                <div className="services_grid">
                    {services.map(service => (
                        <section className="service_card" key={service.number}>
                            <span className="service_num">{service.number}</span>
                            <h2 className="service_title">{service.title}</h2>
                            <p className="service_desc">{service.description}</p>
                            <p className="service_examples_title">Ejemplos de proyectos:</p>
                            <ul className="service_examples">
                                {service.examples.map((example, index) => (
                                    <li key={index}>{example}</li>
                                ))}
                            </ul>
                        </section>
                    ))}
                </div>
            }

            <Footer/>
        </div>
    );

}

export default Services;
